import { Component, ViewEncapsulation, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
declare var jQuery: any;
import * as _ from 'lodash';
import * as moment from 'moment';
import { PrimecalendarService } from './../primecalendar.service';
import {
  MessageEvent, SignInEvent, DatePickerToCalendarEvent, OpenFrameEvent, SidemenuToCalendarEvent,
  LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck
} from './../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
  selector: 'app-prime-calendar',
  templateUrl: 'prime-calendar.component.html',
  styleUrls: ['prime-calendar.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [PrimecalendarService, MessageEvent, SignInEvent,
    DatePickerToCalendarEvent, OpenFrameEvent, SidemenuToCalendarEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck]

})

export class PrimeCalendarComponent implements OnInit, OnDestroy {
  private _router;
  // start prime calendar (full calendar)
  events: any[];
  header: any;
  event: MyEvent;
  dialogVisible: boolean = false;
  idGen: number = 100;
  headerConfig: any;
  // End prime calendar (full calendar)

  private stringConstants = CONSTANT_MESSAGES;
  private paymentFilterArray = ['All', 'Confirmed'];
  private paymentfilter = 'All';
  private currentFilterValue = 'All';
  private popupTitle;
  private eventData = {
    calEvent: {},
    start: '',
    end: '',
    startTimeNew: moment(),
    endTimeNew: moment()
  };
  private selectedUnit = '';
  private shouldSlide: boolean = false;
  private facility_list;
  private showFacilities = false;
  private category = {};
  private viewDataSummaryList = [];
  // private scrollOptions: ISlimScrollOptions;
  private bookingData = [];
  private facility = {
    'name': '',
    'noOfUnits': '',
    'noOfTimes': '',
    'linkType': '',
    'eventType': '',
    'eventName': '',
    'eventId': '',
    'slotDuration': '',

    'category': '',
    'timings': {
      'openTime': '',
      'closeTime': ''
    },
    'unitNames': [],
    'icon': '',
    'isChargable': false,
    'amount': {
      'currency': 'USD',
      'value': ''
    },
    'isHoldBooking': false,
    'holdBookingDays': '',
    'isAttendeeCountRequired': false,
    'reminder': {
      'unit': 'hours',
      'value': ''
    },
    'maxWeekdayBooking': '',
    'maxWeekendBooking': '',
    'isWaitlistEnabled': false,
    'waitlistCount': '',
    'vendorId': '',
    'isActive': true,
    'peekStartTime': '',
    'peekEndTime': '',
    'maxBookingHoursWeekday': '',
    'maxBookingHoursWeekend': '',
    'maxNumberOfPeopleWeekday': '',
    'maxNumberOfPeopleWeekend': '',
    'notificationAcceptanceHour': '',
    'peakUnitsCount': '',
    'createdBy': '',
    'breakTimings': [],
    'peekTimings': [],
    'isMaxBookingPerMembership': false,
    'isMaxBookingPerPerson': false,
    'isPeakTimeEnabled': true,
    'isBreakTimeEnabled': true,
    'maxBookingHoursMonth': '',
    'isCourtSelection': false,
    'holidays': [],
    'isAllowMemberNotes': false,
    'memberNotesHintText': '',
    'vendorNotesHintText': '',
    'isAllowVendorNotes': false,
    'isAllowForceBooking': false,
    'isShowMarkAsVisited': false,
    'isOpenBookingOnFriday': false,
    'activitySlots': [],
    'isSlotsLocked': true,
    'isOpenNextMonthBooking': false,
    'date': '',
    'dateObj': '',
    'expiryDate': '',
    'expiryDateObj': '',

    'location': '',
    'addressLine1': '',
    'addressLine2': '',
    'addressLine3': '',
    'pincode': '',
    'country': 'Singapore',

  };
  private schedulerDate;
  private calendarDate: any;
  private vendor;
  private windowHeight = window.innerHeight;
  private topNav = 56;
  private midNav = 45;
  private footer = 35;
  private container = 20;
  private divHeight = 30;
  private listheight = 11;
  private height: any;
  private startTimeOfFacility: string = '00:00:00';
  private endTimeOfFacility: string = '24:00:00';
  private popUpMessage = CONSTANT_MESSAGES.PAYMENT_RECIEVED_CONFIRMATION;
  private popUpBookingUnavailableMessage = CONSTANT_MESSAGES.SLOT_NO_AVAILABLE_ERROR_MSG;
  private bookingPopupMessage = '';
  private currentEvent: any;
  private facilityRule = {
    'timings': {
      'openTime': '',
      'closeTime': ''
    },
    'peekTimings': [],
    'breakTimings': []
  };
  private peakTimeList = []
  private currentBookingList = [];
  private calendarData;
  private delegate: boolean = false;
  calenderLocale: any = {};
  scheduleLocale: any = {};
  private clubName = '';
  private message = '';
  private filterSate = 'All';
  private selectAll = false;
  private selectConfirmed = false;
  private facilityData = [];
  private unitNameList = [];
  private currency = CONSTANT_VALUES.currency;
  private firstDay;
  private lastDay;
  private bookingSlotStart;
  private bookingSlotEnd;
  private timezoneOffset;
  private utilityFunctions = new UtilityFunctions();
  private viewSummaryFlag = true;
  private blockedDays = [];
  private blockedSlot = [];
  private facilityView = '';

  constructor(private router: Router, private calendarService: PrimecalendarService, private messageEvent: MessageEvent,
    private signInEvent: SignInEvent, private datePickerToCalendarEvent: DatePickerToCalendarEvent, private appService: AppService,
    private openFrameEvent: OpenFrameEvent, private sidemenuToCalendarEvent: SidemenuToCalendarEvent,
    private hiddenFooter: HiddenFooter, private loaderEvent: LoaderEvent, private cd: ChangeDetectorRef,
    private sidemenuSubCategory: SidemenuSubCategory, private setAllMemberCheck: SetAllMemberCheck) {
    this._router = router;
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));

    // We do not specify class name here, if it is a staff role
    if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        this.clubName = subVendor.clubName;
      }
    } else {
      this.clubName = this.vendor.clubName;
    }
    this.emitTypeBroadcast();
    this.registerTypeBroadcast();
    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {

      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        this.appService.getFacilityByClub(subVendor._id);
      }
    } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
      this.appService.getFacilityByClub(this.vendor.vendorId);
    } else {
      this.appService.getFacilityByClub(this.vendor._id);
    }
    if (localStorage.getItem('vendor_facilityData')) {
      this.facilityData = JSON.parse(localStorage.getItem('vendor_facilityData'));
    }
    this.getCategory(null);
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight
      + this.listheight)) + 'px';
  }

  ngOnInit() {
    this.calenderLocale.en = {
      // dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
      firstDayOfWeek: 1,
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    };
    this.timezoneOffset = this.vendor.timezoneOffset * -1;
    let timeZoneDate = moment().utcOffset(this.timezoneOffset);
    let year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = timeZoneDate.hour(), minutes = timeZoneDate.minutes();
    this.calendarDate = (new Date(year, month, date, hour, minutes));
    this.schedulerDate = moment(this.calendarDate).format();
    this.emitOpenFrameEvent();
    this.header = {
      // left: 'prev,next today',
      // center: 'title',
      right: 'agendaDay,agendaWeek' // right: 'month,agendaWeek,agendaDay'
    };
    this.timezoneOffset = this.vendor.timezoneOffset * -1;
    this.events = [];
    this.scheduleLocale.en = {
      firstDay: 1
    }
    // Temporary static events for example and testing purpose

    // this.events = [
    //     {
    //         'title': 'All Day Event',
    //         'start': '2016-11-23'
    //     },
    //     {
    //         'title': 'Long Event',
    //         'start': '2016-11-28T12:00:00.000Z',
    //         'end': '2016-11-28T13:00:00.000Z',
    //         'allDay': false,
    //         'borderColor': 'red',
    //         'textColor': 'blue',
    //         'className': 'tb-full-width'
    //     },
    //     {
    //         'title': 'Repeating Event',
    //         'start': '2016-11-28T16:00:00',
    //         'end': '2016-11-28T17:00:00.000Z',
    //         'allDay': false
    //     },
    //     {
    //         'title': 'Repeating Event',
    //         'start': '2016-11-16T16:00:00'
    //     },
    //     {
    //         'title': 'Conference',
    //         'start': '16:00:00',
    //         'end': '17:00:00',
    //         'allDay': true,
    //         'className': 'closed'
    //     }
    // ];
    this.getFirstAndLastDateOfMonth();
    this.viewSummaryFlag = true;
    let viewFacility;
    if (localStorage.getItem('summaryViewRequest')) {
      viewFacility = JSON.parse(localStorage.getItem('summaryViewRequest'));
      this.facilityView = viewFacility.facilityId;
    }
  }

  ngOnDestroy() {
    jQuery('.ui-widget').fullCalendar('destroy');
  }

  isBookingAllowedForSportsCategory(selectedDate) {
    let currentDate = moment().utcOffset(this.vendor.timezoneOffset * -1, true);
    let lastBookingDate;

    if ((currentDate.day() === 5 && currentDate.hour() >= 18) || _.includes([6, 0], currentDate.day())) {
      lastBookingDate = moment().utcOffset(this.vendor.timezoneOffset * -1, true).day(0 + 7 + 7); // 0+7+7 means upto next Sunday
    } else {
      lastBookingDate = moment().utcOffset(this.vendor.timezoneOffset * -1, true).day(0 + 7); // 0+7 means upto coming Sunday
    }
    return selectedDate.isAfter(lastBookingDate.endOf("day")) ? false : true;
  }

  handleDayClick(e, msgPopUpObj, popUpObj, bookingPopUpObj, bookingUnavailablePopUpObj) {
    if (this.vendor.role.indexOf(CONSTANT_VALUES.SUPER_ADMIN) < 0) {
      //this.currentEvent = e;
      e.date._i[4] = 0;
      let bookingDate = moment(e.date._i).utcOffset(this.vendor.timezoneOffset * -1, true);
      bookingDate.set({ 'second': 0, 'minute': 0, 'millisecond': 0 });
      let currentDate = moment().utcOffset(this.vendor.timezoneOffset * -1);
      this.dialogVisible = true;
      this.popupTitle = this.facility.name;
      /* time zone offset calculation, new start and end based on timezoneOffset*/
      this.eventData.startTimeNew = moment(e.date._i).utcOffset(this.timezoneOffset, true);
      let mom = moment(e.date._i).utcOffset(this.timezoneOffset, true);
      this.eventData.endTimeNew = moment(e.date._i).utcOffset(this.timezoneOffset, true);
      // trigger detection manually as somehow only moving the mouse quickly after click triggers the automatic detection
      this.cd.detectChanges();
      this.startTimeOfFacility = (this.facility.timings.openTime + '').split(':')[0];
      this.endTimeOfFacility = (this.facility.timings.closeTime + '').split(':')[0];
      this.setBookingTime(e);
      //this.handleBookingEndTime();
      let bookingPeriod = this.utilityFunctions.checkFOrBookingPeriod(this.facility.isOpenNextMonthBooking, moment(bookingDate).utcOffset(this.vendor.timezoneOffset * -1, true));
      if (e.jsEvent.target.className.indexOf('closed') !== -1 || bookingDate.isBefore(currentDate) || e.jsEvent.target.className.indexOf('blocked') > -1) {
        this.bookingPopupMessage = CONSTANT_MESSAGES.CANNOT_BOOK_THIS_SLOT_ERROR_MSG;
        msgPopUpObj.showChildModal();
      } else if (this.checkForSports() && !this.isBookingAllowedForSportsCategory(moment(bookingDate).utcOffset(this.vendor.timezoneOffset * -1, true))) {
        bookingUnavailablePopUpObj.showChildModal();
      } else if (this.facility.isOpenNextMonthBooking && !bookingPeriod.isFollowingInBookingPeriod) {
        this.bookingPopupMessage = 'Bookings allowed till ' + bookingPeriod.endOfBookingPeriod.format("MMMM Do YYYY") + ' as per house rules';
        msgPopUpObj.showChildModal();
      } else if (this.checkActivityTimewithBookingTime()) {
        this.bookingPopupMessage = CONSTANT_MESSAGES.CANNOT_BOOK_THIS_SLOT_ERROR_MSG;
        msgPopUpObj.showChildModal();
      }
      // else if (this.eventData.startTimeNew.hour() >= parseInt(this.startTimeOfFacility) &&
      //     (this.eventData.startTimeNew.hour() + parseInt(this.facility.slotDuration) <= parseInt(this.endTimeOfFacility))) {
      //     bookingPopUpObj.showChildModal(null, this.facility);
      // }
      else {
        bookingPopUpObj.showChildModal(null, this.facility);
      }
    } else {
      this.bookingPopupMessage = CONSTANT_MESSAGES.SUPER_ADMIN_NO_BOOKING_ERROR_MSG;
      msgPopUpObj.showChildModal();
    }
  }

  handleEventClick(e, popUpObj, wailistPopUpObj) {
    this.eventData.start = e.calEvent.start._i;
    this.eventData.end = e.calEvent.end._i;
    this.eventData.startTimeNew = moment(e.calEvent.start._i).utcOffset(this.timezoneOffset, true);
    this.eventData.endTimeNew = moment(e.calEvent.end._i).utcOffset(this.timezoneOffset, true);
    this.eventData.calEvent = e.calEvent;
    this.popupTitle = this.facility.name;
    if (e.calEvent.className != 'blocked') {
      this.showViewSummary(popUpObj, e);
    }

    //wailistPopUpObj.showChildModal();
  }

  saveEvent() {
    if (this.event.id) {
      //  update
      let index: number = this.findEventIndexById(this.event.id);
      if (index >= 0) {
        this.events[index] = this.event;
      }
    } else {
      // new
      this.event.id = this.idGen;
      this.events.push(this.event);
      this.event = null;
    }

    this.dialogVisible = false;
  }

  deleteEvent() {
    let index: number = this.findEventIndexById(this.event.id);
    if (index >= 0) {
      this.events.splice(index, 1);
    }
    this.dialogVisible = false;
  }
  // this is one for getting all events from this.currentBookingList
  findEventIndexById(id: number) {
    let index = -1;
    for (let i = 0; i < this.events.length; i++) {
      if (id === this.events[i].id) {
        index = i;
        break;
      }
    }

    return index;
  }

  dateChange(event) {
    this.schedulerDate = this.calendarDate;
    jQuery('.ui-widget').fullCalendar('gotoDate', this.calendarDate);
  }

  monthChange(event) {
    let tempDate1, tempDate2, monthNumber;
    let reg = /jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/i;
    try {
      let monthAndYear: string;
      let month: string;
      let year: string;
      if (event.srcElement.className.indexOf('left') > -1 || event.srcElement.className.indexOf('right') > -1) {
        monthAndYear = event.srcElement.parentElement.parentElement.children[2].innerText.trim();
      } else {
        monthAndYear = event.srcElement.parentElement.parentElement.children[0].innerText.trim();
      }
      if (reg.test(monthAndYear)) {
        month = monthAndYear.split(' ')[0].trim();
        year = monthAndYear.split(' ')[1].trim();
        monthNumber = parseInt(moment().utcOffset(this.timezoneOffset).month(month).format("M")) - 1;
        let tempDate = moment().utcOffset(this.timezoneOffset, true);
        this.firstDay = moment([tempDate.year(), (parseInt(monthNumber) + 1) % 12]).utcOffset(this.timezoneOffset, true);
        this.lastDay = moment(this.firstDay).utcOffset(this.timezoneOffset, true).endOf('month');
        if (this.firstDay < this.bookingSlotStart || this.lastDay > this.bookingSlotEnd) {
          this.unitClickHandler(this.selectedUnit, this.facility['_id'], this.calendarDate);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
     * while menu slide left to right as well as we shift header, footer and body too by broadcaster
     */
  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(bool => {
        this.shouldSlide = bool;
      });

    this.sidemenuToCalendarEvent.on()
      .subscribe(message => {
        this.paymentfilter = this.currentFilterValue;
        this.getCategory(message);
      });
  }

  /**
     * function show menu at add member page by broadcaster
     */

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  /**
     * Temproray function
     */
  homeScreen() {
    this.utilityFunctions.homeScreen(this)
  }

  showFacility(facilityId, unitOnSummary?, calendar?) {
    let holiday = [];
    let unit = unitOnSummary ? unitOnSummary : '';
    let calendarDate = calendar ? calendar : '';
    let that = this;
    if (facilityId) {
      let facilityObj = {};
      facilityObj = this.facility_list.filter(function (rec) {
        if (rec._id === facilityId) {
          return rec;
        }
      });
      this.facility = facilityObj[0];
      this.setPeakTim();
      // Don't remove this code because it will be use in future for business timing
      //    let businessHours = [ // specify an array instead
      //         {
      //             dow: [ 1, 2, 3 ], // Monday, Tuesday, Wednesday
      //             start: this.getGMTHoursFormat(this.facility.timings.openTime), // 8am
      //              end: this.getGMTHoursFormat(this.facility.timings.closeTime) // 6pm
      //          },
      //         {
      //             dow: [ 4, 5 ], // Thursday, Friday
      //             start: '10:00', // 10am
      //             end: '16:00' // 4pm
      //         }
      //     ];
      // jQuery('.ui-widget').fullCalendar('option', {
      //                 minTime: (this.facility.timings.openTime.substring(0, this.facility.timings.openTime.length - 6)),
      //                 maxTime: (this.facility.timings.closeTime.substring(0, this.facility.timings.closeTime.length - 6)),
      //             });
      // jQuery('.ui-widget').fullCalendar('option', 'aspectRatio', 1.6);
      this.facilityRule.peekTimings = [];
      this.facilityRule.breakTimings = [];
      this.modifyTimeToShow();
      //  jQuery('.ui-widget').fullCalendar('option', 'businessHours', businessHours);
      unit = unit ? unit : this.facility.unitNames[0];
      this.calendarDate = this.appService.getCurrentDate() ? this.appService.getCurrentDate() : this.calendarDate;
      this.unitClickHandler(unit, this.facility['_id'], this.calendarDate);
    }
    // this.loaderEvent.fire(true);
  }

  unitClickHandler(unit, facilityId, date) {
    if (this.currentFilterValue === 'All') {
      this.showUnitBookings(unit, facilityId, date, false);
    } else if (this.currentFilterValue === 'Confirmed') {
      this.showUnitBookings(unit, facilityId, date, true);
    }
  }

  showUnitBookings(unitName, facilityId, filterDate, skipWaitlist) {
    this.getFirstAndLastDateOfMonth();
    let startDate, endDate;
    this.loaderEvent.fire(false);
    if (unitName && facilityId) {
      this.events = [];
      this.blockedSlot = [];
      let that = this;
      this.selectedUnit = unitName;
      if (!filterDate) { filterDate = new Date(); }
      let filter1 = moment().utcOffset(this.timezoneOffset, true);
      let filter2 = moment().utcOffset(this.timezoneOffset, true);
      if (this.firstDay < this.bookingSlotStart) {
        startDate = this.firstDay;
        endDate = this.bookingSlotStart;
        this.bookingSlotStart = startDate;
      } else if (this.lastDay > this.bookingSlotEnd) {
        startDate = this.bookingSlotEnd;
        endDate = this.lastDay;
        this.bookingSlotEnd = endDate;
      } else {
        startDate = this.firstDay.utcOffset(this.timezoneOffset, true).subtract(90, 'd');
        endDate = this.lastDay.utcOffset(this.timezoneOffset, true).add(90, 'd')
        this.bookingSlotStart = startDate;
        this.bookingSlotEnd = endDate;
      }
      that.bookingData = [];
      let waitList = [];
      let unitList = [];
      this.facility.breakTimings.map(function (rec) {
        let breakObj = {
          'title': '',
          'start': (rec.start.substring(0, rec.start.length - 6)),
          'end': (rec.end.substring(0, rec.end.length - 6)),
          'allDay': true,
          'className': 'closed',
          'rendering': 'background'
        };
        that.bookingData.push(breakObj);
      });
      this.facility.peekTimings.map(function (rec) {
        let peakTimeObj = {
          'title': '',
          'start': (rec.start.substring(0, rec.start.length - 6)),
          'end': (rec.end.substring(0, rec.end.length - 6)),
          'allDay': true,
          'className': 'peaktime',
          'rendering': 'background'
        };
        that.bookingData.push(peakTimeObj);
      });
      if (this.makeUnavailableAtStart()) {
        that.bookingData.push(this.makeUnavailableAtStart())
      }
      that.bookingData.push(this.makeUnavailableAtEnd());
      let reqObject = {
        'facilityId': facilityId,
        'startDate': moment(startDate).utcOffset(that.timezoneOffset, true),
        'endDate': moment(endDate).utcOffset(that.timezoneOffset, true),
        'vendorId': ''
      };
      if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
        if (this.vendor.subVendors.length > 0) {
          let subVendor = this.vendor.subVendors[0];
          reqObject.vendorId = subVendor._id;
        }
      } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
        reqObject.vendorId = this.vendor.vendorId;
      } else {
        reqObject.vendorId = this.vendor._id;
      }
      that.setBlockDays();
      this.calendarService.getBookingsByFacility(reqObject).then((result: any) => {
        let calendarWidget = jQuery('.ui-widget');
        jQuery('.ui-widget').fullCalendar('gotoDate', that.calendarDate);
        if (localStorage.getItem('view')) {
          let view = localStorage.getItem('view');
          calendarWidget.fullCalendar('changeView', view);
          localStorage.removeItem('view');
        }
        if (result.status === 'SUCCESS') {
          this.currentBookingList = result.bookingData;
          this.currentBookingList.filter(function (rec) {
            if (rec['bookingStatus'] == 'waitlist' && !that.facility.isCourtSelection && !skipWaitlist) {
              unitList.push(rec);
            } else if (rec['unitName'] === unitName) {
              unitList.push(rec);
            }
          });
          let filteredArray = unitList;
          filteredArray.map(function (rec) {
            if (that.currentFilterValue == 'Confirmed' && rec['bookingStatus'] == 'waitlist') {
              return;
            } else {
              let status = (rec['bookingStatus'] == 'waitlist' ? 'waitlist' : 'booked');
              if (rec['isPaymentDone'] !== undefined && rec['isPaymentDone'] == false && that.facility.isChargable) {
                status = (rec['bookingStatus'] == 'waitlist' ? 'waitlist' : 'payment-booked');
              }
              let class_name = (rec['bookingStatus'] == 'booked' && !rec['bookingConfirmed'] ? 'waitlist' : status);
              let title;
              if (that.vendor.isShowMembershipId) {
                title = rec.membershipId;
              } else {
                title = rec.fullName;
              }
              let bookObj = {
                start: moment(rec.startTime).utcOffset(that.timezoneOffset).format(),
                end: moment(rec.endTime).utcOffset(that.timezoneOffset).format(),
                startTime: rec.startTime,
                endTime: rec.endTime,
                title: (status !== 'waitlist' ? title : ''),
                bookingId: rec.bookingId,
                facilityId: rec.facilityId,
                className: class_name,
                status: status,
                bookingStatus: rec['bookingStatus'],
                waitlistCount: rec['waitlistCount'],
                userId: rec['userId'],
                unitName: rec['unitName'] ? rec['unitName'] : '',
                fullName: rec.fullName,
                attendees: rec.attendees,
                isPaymentDone: rec.isPaymentDone,
                bookingConfirmed: rec.bookingConfirmed,
                membershipId: rec.membershipId
              };
              // that.bookingData.push(bookObj);
              // if(that.vendor.roll === CONSTANT_VALUES.SUPER_ADMIN){
              //     bookObj.title = rec. membershipId;
              // }
              if (!that.checkDataObjWithinEvent(bookObj)) {
                that.bookingData.push(bookObj);
              }
            }

          });
          this.calculateMembershipId();
          calendarWidget.fullCalendar('option', {
            minTime: (this.facility.timings.openTime.substring(0, this.facility.timings.openTime.length - 9)) + ':00',
            maxTime: that.calculateEndTime(this.facility.timings.closeTime) + ':00'
            // aspectRatio: 1.6
          });
          calendarWidget.fullCalendar('option', 'height', 520);
          //calendarWidget.fullCalendar('option', 'slotDuration', '00:15:00');
          calendarWidget.fullCalendar('option', 'scrollTime', (this.facility.timings.openTime.substring(0, this.facility.timings.openTime.length - 3)));
          that.events = this.bookingData;
          calendarWidget.fullCalendar('option', 'eventRender', function (event, element) {
            element.find('.fc-time').remove();
          });
          that.loaderEvent.fire(true);
        }
      });
    }
    //this.checkOverLap();
  }

  convertIntoUTCDate(date) {
    let now = new Date();
    switch (typeof date) {
      case 'string': now = new Date(date);
        break;
      case 'number': now = new Date(date);
        break;
      default: now = date;
    }

    let now_utc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(),
      now.getUTCMinutes(), now.getUTCSeconds());
    return now_utc;

  }

  getCategory(category) {
    this.loaderEvent.fire(false);
    let that = this;
    let viewSummaryFacility = localStorage.getItem('facilityIdOnViewSummary') && !category ? JSON.parse(localStorage.getItem('facilityIdOnViewSummary')) : '';
    this.currentFilterValue = viewSummaryFacility.filter ? viewSummaryFacility.filter : this.currentFilterValue;
    this.paymentfilter = this.currentFilterValue;
    this.filterSate = this.currentFilterValue;
    this.maintainFilterState();
    // if (viewSummaryFacility && !category) {
    //     this.showFacility(viewSummaryFacility);
    //     localStorage.removeItem('facilityIdOnViewSummary');
    // } else {
    //     this.showFacility(this.facility_list[0]._id);
    // }
    // jQuery('.ui-widget').fullCalendar('axisFormat', 'H:mm');
    if (!category) {
      this.category = JSON.parse(this.appService.getCategoryForCalendar());
    } else {
      this.category = category;
    }
    let categoryName = '';
    if (this.category) {
      categoryName = this.category['categoryName'];
      localStorage.removeItem('category');
    }
    this.category = {};
    let vendorObj: any = {
      vendorId: ''
    };

    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        vendorObj.vendorId = subVendor._id;
      }
    } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
      vendorObj.vendorId = this.vendor.vendorId;
    } else {
      vendorObj.vendorId = this.vendor._id;
    }
    this.appService.getClubFacility(vendorObj).then((result: any) => {
      if (result.status === 'SUCCESS' && result.facilityData.length > 0) {
        this.showFacilities = true;
        if (categoryName) {
          this.category = _.find(result.facilityData, function (rec) { return (rec['categoryName'] === categoryName); });
        } else {
          this.category = result.facilityData[0];
        }
        if (viewSummaryFacility && !localStorage.getItem('categorySideMenu')) {
          this.category = _.find(result.facilityData, function (rec) { return (rec['categoryName'] === viewSummaryFacility.category); });
          this.facility_list = this.category['data'];
          this.showFacility(viewSummaryFacility.facilityId, viewSummaryFacility.unitForCalendar, viewSummaryFacility.calendarDate);
          this.appService.setCurrentDate(null);
          localStorage.removeItem('facilityIdOnViewSummary');
        } else {
          if (this.category) {
            this.facility_list = this.category['data'];
            this.showFacility(this.facility_list[0]._id);
          } else {
            this.showFacilities = false;
          }
        }

        localStorage.removeItem('categorySideMenu');
        let obj = {
          category: this.category['categoryName'],
          menu: 'Calendar'
        };
        this.sidemenuSubCategory.fire(obj);
      } else {
        this.message = CONSTANT_MESSAGES.MESSAGE_NO_ACTIVITY_ADDED;
        this.loaderEvent.fire(true);
      }
    });
  }

  // Payment by onclick event

  show(bool: boolean, popUpObj) {
    this.loaderEvent.fire(false);
    if (bool && this.currentEvent && !this.currentEvent.waitlistCount && this.currentEvent.className[0] === 'payment-booked') {
      let that = this;
      let paymentObj = {
        'bookingId': this.currentEvent.bookingId,
        '_id': this.currentEvent.userId,
        'vendorId': this.vendor._id
      };
      this.calendarService.makePayment(paymentObj).then((result: any) => {
        if (result.status === 'SUCCESS') {
          this.unitClickHandler(that.selectedUnit, that.facility['_id'], that.calendarDate);
        } else {
        }
      });
    } else {
    }
    this.loaderEvent.fire(true);
  }

  getGMTHoursFormat(str) {
    let utcHr: string;
    let currDate = new Date();
    let timeArr = [];
    timeArr = str.split(':');
    currDate.setUTCHours(parseInt(timeArr[0]), parseInt(timeArr[1]));
    let hr = currDate.getHours();
    if (hr < 10) {
      utcHr = '0' + hr + ':00:00';
      return utcHr;
    } else {
      return hr.toString() + ':00:00';
    }
  }

  getUtcFormat(str) {
    let utcHr: string;
    let timeArr = [];
    timeArr = str.split(':');
    let currDate = new Date();
    currDate.setHours(parseInt(timeArr[0]), parseInt(timeArr[1]), 0, 0);
    let hr = currDate.getUTCHours();
    let min = currDate.getUTCMinutes();
    if (hr < 10) {
      utcHr = '0' + hr + ':' + min;
      return utcHr;
    } else {
      return hr.toString() + ':' + min;
    }
  }

  settUtcFormat(str) {
    let utcHr: string;
    let currDate = new Date();
    let timeArr = [];
    timeArr = str.split(':');
    currDate.setUTCHours(parseInt(timeArr[0]), parseInt(timeArr[1]));
    let hr = currDate.getHours();
    if (hr < 10) {
      utcHr = '0' + hr;
      return utcHr;
    } else {
      return hr.toString();
    }
  }

  modifyTimeToShow() {
    let timeObject = {};
    this.facilityRule.timings.openTime = this.facility.timings.openTime.replace(/:00:00/g, '');
    this.facilityRule.timings.closeTime = this.facility.timings.closeTime.replace(/:00:00/g, '');
    for (let i = 0; i < this.facility.breakTimings.length; i++) {

      timeObject['start'] = this.facility.breakTimings[i].start.replace(/:00:00/g, '');
      timeObject['end'] = this.facility.breakTimings[i].end.replace(/:00:00/g, '');
      this.facilityRule.breakTimings.push(timeObject);
      timeObject = {};
    }
    for (let item of this.facility.peekTimings) {
      timeObject['start'] = item.start.replace(/:00:00/g, '');
      timeObject['end'] = item.end.replace(/:00:00/g, '');
      this.facilityRule.peekTimings.push(timeObject);
      timeObject = {};
    }
  }

  applyFilter() {
    this.events = [];
    this.filterSate = this.paymentfilter;
    if (this.paymentfilter === 'All') {
      this.currentFilterValue = 'All';
      this.unitClickHandler(this.selectedUnit, this.facility['_id'], this.calendarDate);
    } else if (this.paymentfilter === 'Confirmed' && this.currentBookingList) {
      this.loaderEvent.fire(false);
      this.currentFilterValue = 'Confirmed';
      this.bookingData = [];
      let that = this;
      this.calendarData = JSON.parse(JSON.stringify(this.currentBookingList));
      this.facility.breakTimings.map(function (rec) {
        let breakObj = {
          'title': '',
          'start': (rec.start.substring(0, rec.start.length - 6)),
          'end': (rec.end.substring(0, rec.end.length - 6)),
          'allDay': true,
          'className': 'closed',
          'rendering': 'background'
        };
        that.bookingData.push(breakObj);
      });
      this.facility.peekTimings.map(function (rec) {
        let peakTimeObj = {
          'title': '',
          'start': (rec.start.substring(0, rec.start.length - 6)),
          'end': (rec.end.substring(0, rec.end.length - 6)),
          'allDay': true,
          'className': 'peaktime',
          'rendering': 'background'
        };
        that.bookingData.push(peakTimeObj);
      });
      if (this.makeUnavailableAtStart()) {
        that.bookingData.push(this.makeUnavailableAtStart())
      }
      that.bookingData.push(this.makeUnavailableAtEnd());
      this.setBlockDays();
      this.calendarData.map(function (rec) {
        if (!rec.waitlistCount && that.selectedUnit === rec['unitName']) {
          let status;
          if (rec['isPaymentDone'] == false && that.facility.isChargable) {
            status = (rec['isPaymentDone'] ? 'booked' : 'payment-booked');
          } else {
            status = 'booked';
          }
          let class_name = (rec['bookingStatus'] == 'booked' && !rec['bookingConfirmed'] ? 'waitlist' : status);
          let title;
          if (that.vendor.isShowMembershipId) {
            title = rec.membershipId;
          } else {
            title = rec.fullName;
          }
          let bookObj = {
            start: moment(rec.startTime).utcOffset(that.timezoneOffset).format(),
            end: moment(rec.endTime).utcOffset(that.timezoneOffset).format(),
            startTime: rec.startTime,
            endTime: rec.endTime,
            title: (status !== 'waitlist' ? title : ''),
            membershipId: rec.membershipId,
            bookingId: rec.bookingId,
            facilityId: rec.facilityId,
            className: status,
            status: status,
            bookingStatus: rec['bookingStatus'],
            waitlistCount: rec['waitlistCount'],
            userId: rec['userId'],
            unitName: rec.unitName,
            fullName: rec.fullName,
            attendees: rec.attendees,
            isPaymentDone: rec.isPaymentDone,
            bookingConfirmed: rec.bookingConfirmed
            // rendering: 'background'
          };
          // let obj = that.checkDataObjWithinEvent(bookObj);
          if (!that.checkDataObjWithinEvent(bookObj)) {
            that.bookingData.push(bookObj);
          }

        }
      });
      this.events = that.bookingData;
      this.loaderEvent.fire(true);
    }
  }

  bookingForMember(reqObject, popUpObj) {
    if (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      reqObject['vendorId'] = this.vendor._id;
    } else {
      reqObject['vendorId'] = this.vendor.vendorId;
    }
    reqObject['facilityId'] = this.facility['_id'];
    reqObject['isWalkInBooking'] = true;
    reqObject['title'] = this.facility['name'];
    reqObject['unitName'] = this.selectedUnit;
    this.calendarService.bookingForMember(reqObject).then((result: any) => {
      if (result.status === 'SUCCESS') {
      }
      this.bookingPopupMessage = result.message;
      popUpObj.showChildModal();
    });
  }

  refreshPage(e) {
    if (e) {
      if (this.vendor.role.indexOf(CONSTANT_VALUES.SUPER_ADMIN) < 0) {
        this.unitClickHandler(this.selectedUnit, this.facility['_id'], this.calendarDate);
      }
    }

  }

  maintainFilterState() {
    this.paymentfilter = this.filterSate;
    if (this.filterSate === 'All') {
      this.selectAll = true;
      this.selectConfirmed = false;
    } else {
      this.selectAll = false;
      this.selectConfirmed = true;
    }
  }

  timeConvert24to12(time) {
    let time1 = time.split(':');
    let t = parseInt(time1[0]);
    if (isNaN(t)) return '00';
    if (t === 0) return '12' + ':' + time1[1] + 'AM';
    else if (t === 12) return '12' + ':' + time1[1] + 'AM';
    else if (t === 24) return '12' + ':' + time1[1] + 'AM';
    else {
      let suffix = t > 12 ? ' PM' : ' AM';
      return t % 12 + ':' + time1[1] + suffix;
    }
  }

  setPeakTim() {
    this.peakTimeList = [];
    let that = this;
    if (this.facility.peekTimings instanceof Array) {
      this.facility.peekTimings.forEach((r) => {
        this.peakTimeList.push({
          start: that.timeConvert24to12(r.start.replace(':00:00', '')),
          end: that.timeConvert24to12(r.end.replace(':00:00', ''))
        });
      });
    }
  }

  getFirstAndLastDateOfMonth() {
    let tempDate = moment().utcOffset(this.timezoneOffset, true);
    this.firstDay = moment([tempDate.year(), (tempDate.month() + 12) % 12]).utcOffset(this.timezoneOffset, true);
    this.lastDay = moment(this.firstDay).utcOffset(this.timezoneOffset, true).endOf('month');
  }

  deleteBooking(bookingObj) {
    this.unitClickHandler(this.selectedUnit, this.facility['_id'], this.calendarDate);
  }

  checkForSports() {
    // if (_.indexOf(CONSTANT_VALUES.SPORTS, this.facility.category) >= 0) {
    //     return true;
    // } else {
    //     return false;
    // }
    if (this.facility.isOpenBookingOnFriday) {
      return true;
    } else {
      return false;
    }
  }

  showViewSummary(popUpObj, eventData?) {
    this.viewDataSummaryList = this.bookingData;
    this.viewSummaryFlag = false;
    let view = jQuery('.ui-widget').fullCalendar('getView');
    localStorage.setItem('view', view.type);
    this.appService.setCurrentDate(this.calendarDate);
    let summaryViewRequest = {
      facilityId: this.facility['_id'],
      unitName: this.selectedUnit,
      facilityName: this.facility.name,
      unitNames: this.facility.unitNames,
      facilityStart: this.facility.timings.openTime.replace(/:00:00/g, ''),
      facilityEnd: this.facility.timings.closeTime.replace(/:00:00/g, ''),
      facilityEventStart: "",
      facilityEventEnd: "",
      isChargeable: this.facility.isChargable,
      eventDate: "",
      eventStart: '',
      eventEnd: '',
      slotDuration: this.facility.slotDuration,
      category: this.facility.category,
      name: this.facility.name,
      holidays: this.facility.holidays,
      timings: this.facility.timings,
      isAllowMemberNotes: this.facility.isAllowMemberNotes ? this.facility.isAllowMemberNotes : '',
      isAllowForceBooking: this.facility.isAllowForceBooking,
      isShowMarkAsVisited: this.facility.isShowMarkAsVisited,
      filter: this.currentFilterValue,
      unitForCalendar: '',
      activitySlots: this.facility.activitySlots,
      isSlotsLocked: this.facility.isSlotsLocked,
      isOpenNextMonthBooking: this.facility.isOpenNextMonthBooking
    }
    if (eventData) {
      summaryViewRequest.eventDate = eventData.calEvent.start._i;
      summaryViewRequest.facilityEventStart = this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['start']).hour() < 10 ? "0" + this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['start']).hour() + ':' + ('0' + this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['start']).minute()).slice(-2) :
        this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['start']).hour() + ':' + ('0' + this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['start']).minute()).slice(-2);
      summaryViewRequest.facilityEventEnd = this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['end']).hour() < 10 ? "0" + this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['end']).hour() + ':' + ('0' + this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['end']).minute()).slice(-2) :
        this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['end']).hour() + ':' + ('0' + this.utilityFunctions.maketimeZoneOfsetDate(this.eventData['end']).minute()).slice(-2);
      summaryViewRequest.eventStart = eventData.calEvent.start;
      summaryViewRequest.eventEnd = eventData.calEvent.end;
      summaryViewRequest.unitForCalendar = this.selectedUnit
      if (!this.facility.isCourtSelection) {
        summaryViewRequest.unitName = eventData.calEvent.status == 'waitlist' && this.facility.unitNames.length > 1 ? 'All' : this.selectedUnit;
      }

    }
    localStorage.setItem('summaryViewRequest', JSON.stringify(summaryViewRequest));
    this.router.navigate(['/viewsummary']);
  }

  setBlockDays() {
    let that = this;
    let exactStart, exactEnd;
    this.blockedDays = this.facility.holidays ? _.cloneDeep(this.facility.holidays) : [];
    this.blockedDays.forEach(blockObj => {
      blockObj.date = blockObj.date ? moment(blockObj.date, 'DD/MM/YYYY').utcOffset(this.timezoneOffset, true) : '';
      if (blockObj.isFullDay == false) {
        blockObj.slots.forEach(blockSlot => {
          if (blockObj.unitNames.indexOf(that.selectedUnit) >= 0) {
            exactStart = blockSlot.start.split(':');
            exactEnd = blockSlot.end.split(':');
            that.blockedSlot.push({
              //'allDay': true,
              'title': '',
              'start': blockObj.date.set({ 'hour': exactStart[0], 'minute': exactStart[1] }).format(),
              'end': blockObj.date.set({ 'hour': exactEnd[0], 'minute': exactEnd[1] }).format(),
              'className': 'blocked'
              //'rendering': 'background'
            });
          }
        });
      } else if (blockObj.isFullDay) {
        if (blockObj.unitNames.indexOf(that.selectedUnit) >= 0) {
          that.blockedSlot.push({
            //'allDay': true,
            'title': '',
            'start': blockObj.date.set({ 'hour': that.facility.timings.openTime.split(':')[0] }).format(),
            'end': blockObj.date.set({ 'hour': that.calculateEndTime(that.facility.timings.closeTime) }).format(),
            'className': 'blocked',
            //'rendering': 'background'
          });
        }
      }
    });
    this.checkOverLap();
    this.addBlockedEventInBookiingData();
  }

  showBlockDatesPopup(popupObj) {
    popupObj.showChildModal();
  }

  checkDataObjWithinEvent(bookingData) {
    return this.blockedSlot.some((obj) => {
      return (bookingData.start < obj.end && obj.start < bookingData.end);
    });
  }

  checkOverLap() {
    let blockSlots = _.cloneDeep(this.blockedSlot);
    const blockedEvent = _.sortBy(blockSlots, (_event) => { return _event.start; });
    const finalBlocked = [];
    let currentEvent = blockedEvent[0];
    blockedEvent.forEach((_current, _i, _all) => {
      if (_i < _all.length - 1) {
        const _next = _all[_i + 1];
        if (currentEvent.start < _next.end && _next.start < currentEvent.end) {
          currentEvent.start = currentEvent.start < _next.start ? currentEvent.start : _next.start;
          currentEvent.end = currentEvent.end > _next.end ? currentEvent.end : _next.end;
        } else {
          finalBlocked.push(currentEvent);
          currentEvent = _next;
        }
      } else {
        finalBlocked.push(currentEvent);
      }
    });
    this.blockedSlot = finalBlocked;
  }

  addBlockedEventInBookiingData() {
    let that = this;
    this.blockedSlot.forEach(element => {
      that.bookingData.push(element);
    });
  }

  calculateEndTime(closeTime) {
    let closeTimeArray = closeTime.split(':');
    let hour = parseInt(closeTimeArray[0])
    if (parseInt(closeTimeArray[1]) > 0) {
      hour = hour + 1;
    }
    return ('0' + hour).slice(-2);
  }

  setBookingTime(event) {
    let bookingTime = ('0' + this.eventData.startTimeNew.hour()).slice(-2) + ':' + ('0' + this.eventData.startTimeNew.minute()).slice(-2);
    let facilityOpenTime = this.facility.timings.openTime.split(':');
    let facilityStartTime = facilityOpenTime[0] + ':' + facilityOpenTime[1];
    if (bookingTime < facilityStartTime) {
      this.eventData.startTimeNew.set({ 'hour': parseInt(facilityOpenTime[0]) });
      this.eventData.startTimeNew.set({ 'minute': parseInt(facilityOpenTime[1]) });
    } else {
    }
  }

  handleBookingEndTime() {
    let bookingTime = ('0' + this.eventData.endTimeNew.hour()).slice(-2) + ':' + ('0' + this.eventData.endTimeNew.minute()).slice(-2);
    let facilityCloseTime = this.facility.timings.closeTime.split(':');
    let facilityEndTime = facilityCloseTime[0] + ':' + facilityCloseTime[1];
    if (bookingTime > facilityEndTime) {
      this.eventData.endTimeNew.set({ 'hour': parseInt(facilityCloseTime[0]) });
      this.eventData.endTimeNew.set({ 'minute': parseInt(facilityCloseTime[1]) });
    } else {
    }
  }

  checkActivityTimewithBookingTime() {
    let bookingTime = ('0' + this.eventData.startTimeNew.hour()).slice(-2) + ':' + ('0' + this.eventData.startTimeNew.minute()).slice(-2);
    let facilityCloseTime = this.facility.timings.closeTime.split(':');
    let facilityEndTime = facilityCloseTime[0] + ':' + facilityCloseTime[1];
    if (bookingTime > facilityEndTime) {
      return true;
    } else {
      return false;
    }
  }

  makeUnavailableAtStart() {
    let facilityOpenTime = this.facility.timings.openTime.split(':');
    return facilityOpenTime[1] != '00' ? {
      'title': '',
      'start': facilityOpenTime[0] + ':' + '00',
      'end': facilityOpenTime[0] + ':' + facilityOpenTime[1],
      'allDay': true,
      'className': 'closed',
      'rendering': 'background'
    } : '';
  }

  makeUnavailableAtEnd() {
    let facilityOpenTime = this.facility.timings.closeTime.split(':');
    return {
      'title': '',
      'start': facilityOpenTime[0] + ':' + facilityOpenTime[1],
      'end': parseInt(facilityOpenTime[0]) + 1 + ':' + '00',
      'allDay': true,
      'className': 'closed',
      'rendering': 'background'
    }
  }

  calculateMembershipId() {
    let bookingData = this.bookingData;
    let that = this;
    let waitListArray = this.bookingData.map(function (rec: any) {
      if (rec.bookingStatus == 'waitlist') {
        rec.title = that.getbookingTitle(rec.start, rec.end);
      } else {
      }
      return rec;
    });
  }

  getbookingTitle(start, end) {
    let booking = _.find(this.bookingData, function (params: any) {
      if (start < params.end && end > params.start && (params.bookingStatus != 'waitlist' || (params.bookingStatus == 'waitlist' && params.bookingConfirmed == false))) {
        return params
      }
    });
    return booking ? booking.membershipId : '';
  }
}

export class MyEvent {
  id: number;
  title: string;
  start: string;
  end: string;
  allDay: boolean = true;
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/prime-calendar/prime-calendar.component.ts